module.exports = __webpack_public_path__ + "img/showStatus4.fc5507b7.png";